import { render, staticRenderFns } from "./EditProduct copy.vue?vue&type=template&id=18e3a7cd&scoped=true"
import script from "./EditProduct copy.vue?vue&type=script&lang=js"
export * from "./EditProduct copy.vue?vue&type=script&lang=js"
import style0 from "./EditProduct copy.vue?vue&type=style&index=0&id=18e3a7cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e3a7cd",
  null
  
)

export default component.exports